/**
 * Product card Swiper - auto-initializes all product card image sliders.
 * Requires Swiper (https://swiperjs.com) to be loaded before this script.
 *
 * Load in your theme (e.g. theme.liquid or collection template):
 *   <script src="https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js" defer></script>
 *   {{ 'card-product-swiper.js' | asset_url | script_tag }}
 */
(function() {
  function initProductCardSwipers() {
    const swipers = document.querySelectorAll('[data-product-card-swiper]');
    if (!swipers.length || typeof Swiper === 'undefined') return;

    swipers.forEach(function(swiperEl) {
      if (swiperEl.swiper) return; // already initialized

      const prevBtn = swiperEl.querySelector('.swiper-button-prev');
      const nextBtn = swiperEl.querySelector('.swiper-button-next');
      const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');

      new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        grabCursor: true,
        watchSlidesProgress: true,
        navigation: prevBtn && nextBtn ? {
          prevEl: prevBtn,
          nextEl: nextBtn
        } : false,
        scrollbar: scrollbarEl ? {
          el: scrollbarEl,
          draggable: true,
          hide: false
        } : false,
        on: {
          init: function() {
            const slides = this.slides.length;
            if (prevBtn) prevBtn.style.display = slides > 1 ? '' : 'none';
            if (nextBtn) nextBtn.style.display = slides > 1 ? '' : 'none';
            if (scrollbarEl) scrollbarEl.style.display = slides > 1 ? '' : 'none';
          }
        }
      });
    });
  }

  function tryInit() {
    if (typeof Swiper !== 'undefined') {
      initProductCardSwipers();
    } else {
      setTimeout(tryInit, 50);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  document.addEventListener('shopify:section:load', initProductCardSwipers);
})();
